import { DeviceModelRefV2 } from '@csp/config-schemas';
import {
  DeviceObservationType,
  DeviceModelNumberType,
  ObservationContextType,
  DeviceConfigOverride,
} from '@csp/device-catalog';

export type DeviceObservationRequestModelRefV1 = {
  modelNumber: DeviceModelNumberType;
  observationType: DeviceObservationType;
  contextType: ObservationContextType;
  configOverride?: DeviceConfigOverride;
};

const from = (deviceModelRefV2: DeviceModelRefV2): DeviceObservationRequestModelRefV1 => {
  const modelNumber = deviceModelRefV2.ref.value as DeviceModelNumberType;
  return {
    modelNumber,
    observationType: deviceModelRefV2.meta?.observationType,
    contextType: deviceModelRefV2.meta?.contextType,
    configOverride: deviceModelRefV2.meta?.configOverride,
  };
};

export const DeviceObservationRequestModelRefV1 = {
  from,
};
